import { useState } from "react";
import SettingPage from "../settings/setting-page";
import ImageButton from "./image-button";

export default function SettingButton() {
  const [isSettingOpen, setIsSettingOpen] = useState(false);

  return (
    <>
      <ImageButton
        onClick={() => setIsSettingOpen(true)}
        src="/assets/settings.png"
        alt="settings"
        size={32}
      />
      {isSettingOpen && (
        <div className="fixed inset-0 z-50">
          <SettingPage
            onClose={() => {
              setIsSettingOpen(false);
            }}
          />
        </div>
      )}
    </>
  );
}
